import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch } from 'react-router'
import BackgroundPage from 'src/components/BackgroundPage/BackgroundPage'
import LoadingBackgroundPage from 'src/components/LoadingBackgroundPage/LoadingBackgroundPage'
import NotFoundBackgroundPageContent from 'src/components/NotFoundBackgroundPageContent/NotFoundBackgroundPageContent'
import TitleHeader from 'src/components/TitleHeader/TitleHeader'
import { appStatisticsKeys } from 'src/globalDebouncedDispatcher'
import Trns from 'src/localization/Trns'
import AccountsAppRoute from 'src/navigation/appRoutes/accounts.appRoute'
import { Rdrct } from 'src/navigation/Lnk'
import { accountsAccountsUrl, accountsBudgetsUrl } from 'src/navigation/urls'
import {
  selectAllStatisticsLoadedFromState,
  selectStatisticsDispatcherFromState,
} from 'src/redux/selectors/app.selectors'
import { selectCreditCardsSourceCountStatisticsFromState } from 'src/redux/selectors/data/statistics.selectors'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

const Accounts: React.FC = () => {
  const calculatedBackgroundLocation = useSelector(
    selectCalculatedBackgroundLocation,
  )
  const statisticsLoaded = useSelector(selectAllStatisticsLoadedFromState)
  const creditCardsSourceCount = useSelector(
    selectCreditCardsSourceCountStatisticsFromState,
  )

  const dispatchStatistics = useSelector(selectStatisticsDispatcherFromState)

  useEffect((): void => {
    dispatchStatistics([
      appStatisticsKeys.CreditCardsSourceBudgetsEnabledCountStatistics,
      appStatisticsKeys.CreditCardsDelegateCountStatistics,
      appStatisticsKeys.CreditCardsSourceCountStatistics,
    ])
  }, [dispatchStatistics])

  return !(
    statisticsLoaded.creditCardsSourceBudgetsEnabledCountStatisticsLoaded &&
    statisticsLoaded.creditCardsDelegateCountStatisticsLoaded &&
    statisticsLoaded.creditCardsSourceCountStatisticsLoaded
  ) ? (
    <LoadingBackgroundPage />
  ) : (
    <BackgroundPage>
      <TitleHeader title={<Trns source={'Physical Cards'} />} />
      <Switch location={calculatedBackgroundLocation}>
        {AccountsAppRoute.subRoutes.map((route, i) => (
          <Route key={i} {...route.routeProps}>
            {route.component}
          </Route>
        ))}
        <Route {...AccountsAppRoute.routeProps} exact>
          <Rdrct
            to={
              creditCardsSourceCount > 0
                ? accountsAccountsUrl()
                : accountsBudgetsUrl()
            }
          />
        </Route>
        <Route path={'/'}>
          <NotFoundBackgroundPageContent />
        </Route>
      </Switch>
    </BackgroundPage>
  )
}

export default Accounts
